export var ModalType;
(function(ModalType) {
    ModalType["STATUS_UPDATE"] = "STATUS_UPDATE";
    ModalType["JOURNAL"] = "JOURNAL";
    ModalType["LITERATURE"] = "LITERATURE";
    ModalType["COMMISSION"] = "COMMISSION";
    ModalType["CONFIRMATION"] = "CONFIRMATION";
    ModalType["GLOBAL_CONFIRMATION"] = "GLOBAL_CONFIRMATION";
    ModalType["GLOBAL_CONFIRMATION_FOR_MM"] = "GLOBAL_CONFIRMATION_FOR_MM";
    ModalType["POLL_EDIT"] = "POLL_EDIT";
    ModalType["GIVE_BADGE"] = "GIVE_BADGE";
    ModalType["GIVE_ITEM_FAILURE"] = "GIVE_ITEM_FAILURE";
    ModalType["COMMENT_THREAD"] = "COMMENT_THREAD";
    ModalType["VERIFICATION"] = "VERIFICATION";
    ModalType["VERIFICATION_SUCCESSFUL"] = "VERIFICATION_SUCCESSFUL";
    ModalType["DEVIATION_BACKGROUND_PICKER"] = "DEVIATION_BACKGROUND_PICKER";
    ModalType["USER_BLOCK"] = "USER_BLOCK";
    ModalType["REPORT_DEVIATION_MODAL"] = "REPORT_DEVIATION_MODAL";
    ModalType["MOBILE_DEVIATION_SHARE"] = "MOBILE_DEVIATION_SHARE";
    ModalType["SHARE_LINK"] = "SHARE_LINK";
    ModalType["DEVIATION_GROUP_LIST"] = "DEVIATION_GROUP_LIST";
    ModalType["MOBILE_DEVIATION_PCP"] = "MOBILE_DEVIATION_PCP";
    ModalType["USER_SYMBOLS_LEGEND"] = "USER_SYMBOLS_LEGEND";
    ModalType["MOBILE_CHAT_LIST"] = "MOBILE_CHAT_LIST";
    ModalType["MOBILE_CHAT_WINDOW"] = "MOBILE_CHAT_WINDOW";
    ModalType["MOBILE_CHAT_WINDOW_NEW"] = "MOBILE_CHAT_WINDOW_NEW";
    ModalType["AWARD_BADGE"] = "AWARD_BADGE";
    ModalType["RECEIVED_AWARDS"] = "RECEIVED_AWARDS";
    ModalType["TIER_EDIT"] = "TIER_EDIT";
    ModalType["TIER_UNSUBSCRIBE"] = "TIER_UNSUBSCRIBE";
    ModalType["TIER_UNSUBSCRIBE_BY_USERNAME"] = "TIER_UNSUBSCRIBE_BY_USERNAME";
    ModalType["TIER_CHANGE"] = "TIER_CHANGE";
    ModalType["MOBILE_SHARE"] = "MOBILE_SHARE";
    ModalType["GROUP_CLOSED_WATCH"] = "GROUP_CLOSED_WATCH";
    ModalType["GROUP_JOIN_PENDING"] = "GROUP_JOIN_PENDING";
    ModalType["FAVOURITED_BY"] = "FAVOURITED_BY";
    ModalType["DEVIANTS_LIST"] = "DEVIANTS_LIST";
    ModalType["COLLECTION_POPOVER"] = "COLLECTION_POPOVER";
    ModalType["LOADING_SCREEN"] = "LOADING_SCREEN";
    ModalType["CREATE_PREMIUM_FOLDER"] = "CREATE_PREMIUM_FOLDER";
    ModalType["DEVIATION_SUBMIT"] = "DEVIATION_SUBMIT";
    ModalType["DISCORD_CONNECT_SUCCESS"] = "DISCORD_CONNECT_SUCCESS";
    ModalType["DISCORD_DISCONNECT"] = "DISCORD_DISCONNECT";
    ModalType["BADGE_INFO"] = "BADGE_INFO";
    ModalType["ADD_TO_GROUP"] = "ADD_TO_GROUP";
    ModalType["ADOPT_SELLER_MODAL"] = "ADOPT_SELLER_MODAL";
    ModalType["ADOPT_BUYER_MODAL"] = "ADOPT_BUYER_MODAL";
    ModalType["EXCLUSIVE_TRANSACTION_HISTORY_MODAL"] = "EXCLUSIVE_TRANSACTION_HISTORY_MODAL";
    ModalType["EXCLUSIVE_RESALE_WAIT_WINDOW_MODAL"] = "EXCLUSIVE_RESALE_WAIT_WINDOW_MODAL";
    ModalType["CONTENT_FILTER_SETTINGS"] = "CONTENT_FILTER_SETTINGS";
    ModalType["AI_SUPPRESSION_SETTINGS"] = "AI_SUPPRESSION_SETTINGS";
    ModalType["BIRTHDAYS"] = "BIRTHDAYS";
    ModalType["MOBILE_NOTES_DRAWER"] = "MOBILE_NOTES_DRAWER";
    ModalType["DEVIATION_SUBMIT_SCHEDULE"] = "DEVIATION_SUBMIT_SCHEDULE";
    ModalType["DEVIATION_SUBMIT_SCHEDULE_LIMIT_REACHED"] = "DEVIATION_SUBMIT_SCHEDULE_LIMIT_REACHED";
    ModalType["STUDIO_PRESETS"] = "STUDIO_PRESETS";
    ModalType["STUDIO_BATCH_EDIT"] = "STUDIO_BATCH_EDIT";
    ModalType["STUDIO_TIER_CREATE"] = "STUDIO_TIER_CREATE";
    ModalType["SAFE_URL"] = "SAFE_URL";
})(ModalType || (ModalType = {}));
